module.exports = __webpack_public_path__ + "img/side-dashboard.70282f38.svg";